import { ThemeChoices } from '../systemTheme/types'

export enum ThemeDefaultColorsEnum {
  PRIMARY_COLOR = 'primary_color',
  PRIMARY_TEXT_COLOR = 'primary_text_color',
  PRIMARY_COLOR_DARK = 'primary_color_dark',
  SECONDARY_COLOR = 'secondary_color',
  SECONDARY_TEXT_COLOR = 'secondary_text_color',
  INVOICE_LATE_COLOR = 'invoice_late_color',
  INVOICE_PAID_COLOR = 'invoice_paid_color',
  INVOICE_OPEN_COLOR = 'invoice_open_color',
  ERROR_COLOR = 'error_color',
}

export enum ThemeAmethystColors {
  PRIMARY_COLOR = 'primary_color',
  BRAND_COLOR = 'brand',
  TEXT_COLOR = 'text_color',
  PAID_COLOR = 'paid_color',
  LATE_COLOR = 'late_color',
  OPEN_COLOR = 'open_color',
}

export interface IColorProps {
  key: string
  name: string
  defaultColor: string
}

export interface ITheme {
  theme: string
  suggestion: Record<'light' | 'dark', Record<string, string>>[]
}

export interface ICustomTheme<T = Record<string, string>> {
  theme: string
  themeID: ThemeChoices | null
  appearance?: 'light' | 'dark'
  colors: T
}
